<div class="c-user-menu__item c-user-menu__item--region">
  <label
    class="c-user-menu__label"
    for="region">
    {{ "usersettings.region" | translate }}
    <app-loading-icon
      *ngIf="isLoading || !regions"
      class="u-color--light"></app-loading-icon>
  </label>
  <form
    *ngIf="regionForm"
    [formGroup]="regionForm">
    <mat-select
      name="region"
      id="region"
      class="c-user-menu__select c-select c-select--lg"
      formControlName="region">
      <mat-option
        *ngFor="let r of regions"
        [value]="r.region">
        {{ r.region }}
      </mat-option>
    </mat-select>
  </form>
</div>
